export default "__VITE_ASSET__DDLNGZzi__"